export default {
    type: 'news-item-programme-areas',
    aliases: {
        camel: 'newsItemProgrammeAreas',
        singular: 'News item programme area',
        plural: 'News item programme areas',
        lowerSingular: 'news item programme area',
        lowerPlural: 'news item programme areas',
    },
    publishable: false,
    adminSection: null,
    componentType: 'pivot',
    components: {}
};
